export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/activityTracker.worker.9c3af123.worker.js");
}
